// extracted by mini-css-extract-plugin
export default {"onImage":"JEzdAx","second":"Xgtzv4","third":"yWmqAi","eventInfo":"Q2EFVl","text":"IUS3br","container":"Dnx0V0","badge":"LlobFR","fullWidth":"ZDnSD3"};